import { useState } from 'react';
import { ImageOff, X } from 'lucide-react';
import { normalizeMediaSrc } from '@/lib/mediaUrl';

interface ImageBlockProps {
  src: string;
  alt?: string;
  className?: string;
}

export function ImageBlock({ src, alt = '', className = '' }: ImageBlockProps) {
  const [error, setError] = useState(false);
  const [zoomed, setZoomed] = useState(false);
  const resolvedSrc = normalizeMediaSrc(src);

  if (error) {
    return (
      <div className={`flex flex-col items-center justify-center py-8 bg-surface rounded-xl border border-line ${className}`}>
        <ImageOff className="w-8 h-8 text-fg-faint mb-2" />
        <span className="text-xs text-fg-faint">Image non disponible</span>
      </div>
    );
  }

  return (
    <>
      <img
        src={resolvedSrc}
        alt={alt}
        loading="lazy"
        onClick={() => setZoomed(true)}
        onError={() => setError(true)}
        className={`max-w-full h-auto rounded-xl max-h-64 sm:max-h-96 object-contain cursor-zoom-in my-2 ${className}`}
      />

      {zoomed && (
        <div
          className="fixed inset-0 z-[200] bg-black/90 flex items-center justify-center p-4"
          onClick={() => setZoomed(false)}
        >
          <button className="absolute top-4 right-4 text-fg-muted hover:text-fg">
            <X className="w-6 h-6" />
          </button>
          <img
            src={resolvedSrc}
            alt={alt}
            className="max-w-full max-h-full object-contain rounded-lg"
          />
        </div>
      )}
    </>
  );
}
